import { IFeatureFlags } from "config";
import { gql } from "config/graphql";
import { FEATURE_FLAG_FIELDS } from "gql/fragments";
import { gqlQuery } from "store/apollo";

export const globalFeatureFlagQuery = (): Promise<{
  data: { globalFeatureFlags: IFeatureFlags[] };
}> => {
  const query = gql`
    ${FEATURE_FLAG_FIELDS}
    query GlobalFeatureFlags {
      globalFeatureFlags {
        ...FeatureFlagFields
      }
    }
  `;

  return gqlQuery<{ globalFeatureFlags: IFeatureFlags[] }>({ query });
};
